import { numberToPrettyString } from '@cian/utils';

import { IOffer } from '../../../types/offer';

function formatVatPrice(to?: number | null, from?: number | null): string {
  if (to) {
    return `${numberToPrettyString(to)} ₽`;
  }

  if (from) {
    return `${numberToPrettyString(from)} ₽`;
  }

  return '';
}

export function getVatTypeWithVatPrice(offer: IOffer): string | undefined {
  const { bargainTerms, minVatPriceTotalRur, vatPriceTotalRur, minVatPriceTotalPerMonthRur, vatPriceTotalPerMonthRur } =
    offer;
  const vatType = bargainTerms?.vatType;

  switch (vatType) {
    case 'usn':
      return 'УСН';

    case 'included':
      switch (offer.dealType) {
        case 'sale':
          return `Включая НДС ${formatVatPrice(vatPriceTotalRur, minVatPriceTotalRur)}`;
        case 'rent':
          return `Включая НДС ${formatVatPrice(vatPriceTotalPerMonthRur, minVatPriceTotalPerMonthRur)}`;
        default:
          return 'Включая НДС';
      }

    case 'notIncluded':
      return 'НДС не облагается';

    default:
      return undefined;
  }
}
